import { Navigate, Routes, Route } from "react-router-dom";
import MonthClosure from "./components/MonthClosure";
import { Container } from "./styles";
import UserBills from "./components/UserBills";
import { Transactions } from "./components/Transactions";

interface FinancialProps {
  initialTab?: number;
}

export function Financial({ initialTab }: FinancialProps) {
  if (initialTab !== undefined) {
     if (initialTab === 0) return <Container><MonthClosure /></Container>;
     if (initialTab === 1) return <Container><UserBills /></Container>;
     if (initialTab === 2) return <Container><Transactions /></Container>;
  }

  // Fallback se acessar apenas /financial, redireciona para reports (ou a que preferir)
  return <Navigate to="/financial/reports" replace />;
}
